module.exports = __webpack_public_path__ + "img/qys-ac1.0a753780.jpg";